

export const index = 6;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(admin)/admin/login/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/6.BbWPaJH5.js","_app/immutable/chunks/CslV50be.js","_app/immutable/chunks/C3H89rdt.js","_app/immutable/chunks/CuhEQ3BH.js","_app/immutable/chunks/BN8CHBz-.js","_app/immutable/chunks/DFQvIDzh.js","_app/immutable/chunks/BC3vKV3c.js","_app/immutable/chunks/CWir8Kn7.js"];
export const stylesheets = [];
export const fonts = [];
